import inputAutocomplete from "../input-autocomplete";

const commonInputAutocomplete = {
  install: function (Vue) {
    Vue.component("commonInputAutocomplete", inputAutocomplete);
  },
};

// 导出该组件

export default commonInputAutocomplete;
